// extracted by mini-css-extract-plugin
export default {"bannerContent":"NewsBanner_bannerContent__aelYp"};